import { Pipe, PipeTransform } from '@angular/core';
import { LanguageModel } from '../../../services';
import { FormGroup, AbstractControl } from "@angular/forms";

@Pipe({
  name: 'formGroupGetLocalized'
})
export class FormGroupGetLocalizedPipe implements PipeTransform {

  transform(formGroup: FormGroup, name: string, language: LanguageModel): AbstractControl {
    return formGroup.get(`${name}_${language.data.code.iv}`);
  }

}
